'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAnonymous = exports.isAuthenticated = exports.selectToken = exports.selectUid = exports.selectAuthUser = exports.selectAuth = undefined;

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

var _defaultTo2 = require('lodash/defaultTo');

var _defaultTo3 = _interopRequireDefault(_defaultTo2);

exports.selectUser = selectUser;

var _capeSelect = require('cape-select');

var _reduxGraph = require('redux-graph');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectAuth = exports.selectAuth = (0, _property3.default)('auth');
var selectAuthUser = exports.selectAuthUser = (0, _capeSelect.select)(selectAuth, 'user');
var selectUid = exports.selectUid = (0, _capeSelect.select)(selectAuthUser, 'id');
var selectToken = exports.selectToken = (0, _capeSelect.select)(selectAuth, 'token');

function selectUser(state) {
  var usr = selectAuthUser(state);
  if ((0, _reduxGraph.isEntityCreated)(usr)) {
    return (0, _defaultTo3.default)((0, _reduxGraph.getEntity)(state, usr), usr);
  }
  return usr;
}
var isAuthenticated = exports.isAuthenticated = (0, _capeSelect.select)(selectAuth, 'authenticated');
var isAnonymous = exports.isAnonymous = (0, _negate3.default)(isAuthenticated);


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-auth/lib/select.js
// module id = 836
// module chunks = 0